import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../locales/translations';
import { StudentRiskEvaluationEnrollmentState } from '../types';

type RiskStateBadgeProps = {
  state: StudentRiskEvaluationEnrollmentState;
};

const BG = {
  [StudentRiskEvaluationEnrollmentState.Active]: '#CEF0DA',
  [StudentRiskEvaluationEnrollmentState.Inactive]: '#F2C0BD',
};

const RiskStateBadge = ({ state }: RiskStateBadgeProps) => {
  const { t } = useTranslation(
    TranslationsKeys.STUDENT_RISK_EVALUATION_SESSIONS_STUDENTS,
  );

  return (
    <div className="d-flex w-100 align-items-center justify-content-center">
      <div
        className="d-flex align-items-center justify-content-start py-2 px-4"
        style={{ backgroundColor: BG[state], borderRadius: '24px' }}
      >
        <span>{t(`states.${state ?? 'NULL'}`)}</span>
      </div>
    </div>
  );
};

export default RiskStateBadge;
